<zah-client-header label="Zoek cliënt">
</zah-client-header>

<div class="content">
  @if (isSearchEnabled() && !isSearchingClientficheOrMeldingenEnabled()) {
    <zah-clientnummer-selector
      (clientnummerSelected)="onClientNummerSelected($event)"
      actieLabel="Start"
      actiePalette="primary">
      <div class="hint mat-small">Start een prestatie door de QR code te scannen</div>
    </zah-clientnummer-selector>
  }

  @if (isSearchEnabled() && isSearchingClientficheOrMeldingenEnabled()) {
    <zah-clientnummer-input
      (nummerInput)="onClientNummerForClientFicheSelected($event)">
    </zah-clientnummer-input>
  }
  @if (isSearchEnabled() && !isSearchingClientficheOrMeldingenEnabled()) {
    <a
      mat-button
      color="primary"
      (click)="searchForClientfiche()">
      Bekijk cliënt
    </a>
  }
  @if (isSearchEnabled() && isSearchingClientficheOrMeldingenEnabled()) {
    <a
      mat-button
      color="primary"
      (click)="searchForClientToStartPrestatie()">
      Terug naar start pagina
    </a>
  }

  @if (thuisverzorger$ | async; as thuisverzorger) {
    @if (diensten$ | async; as diensten) {
      @if (client$ | async; as client) {
        <div
          class="client">
          <zah-client [client]="client"></zah-client>
          <div class="buttons">
            <a mat-button
               color="primary"
               (click)="enableSearch()">
              Opnieuw zoeken
            </a>
            @if (!isSearchingClientficheOrMeldingenEnabled()) {
              <button
                mat-raised-button
                color="primary"
                [disabled]="prestatieStarted"
                (click)="startPrestatie(client, thuisverzorger, diensten)">
                Start
              </button>
            }
            @if (isSearchingClientficheOrMeldingenEnabled()) {
              <button
                mat-raised-button
                color="primary"
                [disabled]="prestatieStarted"
                (click)="navigateToClientFiche(client)">
                Cliëntfiche
              </button>
              <button
                mat-raised-button
                color="primary"
                [disabled]="prestatieStarted"
                (click)="navigateToClientMeldingen(client)">
                Meldingen
              </button>
            }
          </div>
        </div>
      }
    }
  }
</div>
